import { Link, Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import type { ComplexBetSlipErrorConfig } from '@swf/sports/config/bet-slip-errors';

import styles from './TranslationWithLink.scss';

const TranslationWithLink: React.FC<ComplexBetSlipErrorConfig> = ({
  contentTranslationTag,
  alias,
  resolverTag
}) => {
  if (!resolverTag && !alias) {
    return <Translation {...contentTranslationTag} />;
  }

  return (
    <Translation
      values={{
        a: (linkText: string) =>
          resolverTag ? (
            <ResolverLink resolverTag={resolverTag} className={styles.link}>
              {linkText}
            </ResolverLink>
          ) : (
            <Link alias={alias} className={styles.link}>
              {linkText}
            </Link>
          )
      }}
      {...contentTranslationTag}
    />
  );
};

export default TranslationWithLink;
